import { render, staticRenderFns } from "./MariChatIntroModal.vue?vue&type=template&id=3856d158&scoped=true"
import script from "./MariChatIntroModal.vue?vue&type=script&lang=js"
export * from "./MariChatIntroModal.vue?vue&type=script&lang=js"
import style0 from "./MariChatIntroModal.vue?vue&type=style&index=0&id=3856d158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856d158",
  null
  
)

export default component.exports